import o from "./z-index-manager.js";
const n = "@@ziContext", u = {
  mounted(e, t) {
    const { value: d = {} } = t, { zIndex: i, enabled: a } = d;
    e[n] = {
      enabled: !!a,
      initialized: !1
    }, a && (o.ensureZIndex(e, i), e[n].initialized = !0);
  },
  updated(e, t) {
    const { value: d = {} } = t, { zIndex: i, enabled: a } = d, s = e[n].enabled;
    a && !s && (o.ensureZIndex(e, i), e[n].initialized = !0), e[n].enabled = !!a;
  },
  unmounted(e, t) {
    if (!e[n].initialized)
      return;
    const { value: d = {} } = t, { zIndex: i } = d;
    o.unregister(e, i);
  }
}, r = u;
export {
  r as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/vdirs@0.1.8_vue@3.5.18/~/vdirs/es/zindexable/index.js
// module id = 337
// module chunks = 67